export const iconValues = [
  {
    value: "",
    label: "None",
    icon: "",
  },
  {
    value: "alternatePlane1",
    label: "Alternate Plane",
    icon: "flight"
  },
  {
    value: "alternatePlane2",
    label: "Alternate Plane",
    icon: "multiple_airports",
  },
  {
    value: "mailBulk",
    label: "Mail Bulk",
    icon: "stacked_email",
  },
  {
    value: "alternateCar",
    label: "Alternate Car",
    icon: "directions_car",
  },
  {
    value: "location",
    label: "Location",
    icon: "location_on",
  },
  {
    value: "addressCard",
    label: "Address Card",
    icon: "contact_mail",
  },
  {
    value: "baguette",
    label: "Baguette",
    icon: "bakery_dining",
  },
  {
    value: "bowlHot",
    label: "Bowl Hot",
    icon: "ramen_dining",
  },
  {
    value: "bowlRice",
    label: "Bowl Rice",
    icon: "rice_bowl",
  },
  {
    value: "cableCar",
    label: "Cable Car",
    icon: "tram",
  },
  {
    value: "candles",
    label: "Candles",
    icon: "emoji_objects",
  },
  {
    value: "cartAdd",
    label: "Cart Add",
    icon: "add_shopping_cart",
  },
  {
    value: "cartDownload",
    label: "Cart Download",
    icon: "shopping_cart_checkout",
  },
  {
    value: "cheese",
    label: "Cheese",
    icon: "bakery_dining",
  },
  {
    value: "child",
    label: "Child",
    icon: "child_care",
  },
  {
    value: "circleHalf",
    label: "Circle Half",
    icon: "adjust",
  },
  {
    value: "circleQuarter",
    label: "Circle Quarter",
    icon: "donut_large",
  },
  {
    value: "circleThreeQuarter",
    label: "Circle Three Quarter",
    icon: "donut_small",
  },
  {
    value: "collapseAlt",
    label: "Collapse Alt",
    icon: "unfold_less",
  },
  {
    value: "collapseHorizontal",
    label: "Collapse Horizontal",
    icon: "unfold_less",
  },
  {
    value: "collapseVertical",
    label: "Collapse Vertical",
    icon: "unfold_less",
  },
  {
    value: "color",
    label: "Color",
    icon: "palette",
  },
  {
    value: "cricketBall",
    label: "Cricket Ball",
    icon: "sports_cricket",
  },
  {
    value: "cross",
    label: "Cross",
    icon: "close",
  },
  {
    value: "expandHorizontal",
    label: "Expand Horizontal",
    icon: "unfold_more",
  },
  {
    value: "expandVertical",
    label: "Expand Vertical",
    icon: "unfold_more",
  },
  {
    value: "fork",
    label: "Fork",
    icon: "restaurant",
  },
  {
    value: "hardHat",
    label: "Hard Hat",
    icon: "engineering",
  },
  {
    value: "homeAlt",
    label: "Home Alt",
    icon: "home",
  },
  {
    value: "horizontalLeft",
    label: "Horizontal Left",
    icon: "align_horizontal_left",
  },
  {
    value: "horizontalRight",
    label: "Horizontal Right",
    icon: "align_horizontal_right",
  },
  {
    value: "injection",
    label: "Injection",
    icon: "vaccines",
  },
  {
    value: "knife",
    label: "Knife",
    icon: "restaurant",
  },
  {
    value: "leaf",
    label: "Leaf",
    icon: "eco",
  },
  {
    value: "lemon",
    label: "Lemon",
    icon: "bakery_dining",
  },
  {
    value: "maleFemale",
    label: "Male Female",
    icon: "wc",
  },
  {
    value: "math",
    label: "Math",
    icon: "functions",
  },
  {
    value: "moneyWithdraw",
    label: "Money Withdraw",
    icon: "atm",
  },
  {
    value: "noSignal",
    label: "No Signal",
    icon: "signal_cellular_off",
  },
  {
    value: "objectsHorizontalCenter",
    label: "Objects Horizontal Center",
    icon: "align_horizontal_center",
  },
  {
    value: "objectsHorizontalLeft",
    label: "Objects Horizontal Left",
    icon: "align_horizontal_left",
  },
  {
    value: "objectsHorizontalRight",
    label: "Objects Horizontal Right",
    icon: "align_horizontal_right",
  },
  {
    value: "objectsVerticalBottom",
    label: "Objects Vertical Bottom",
    icon: "align_vertical_bottom",
  },
  {
    value: "objectsVerticalCenter",
    label: "Objects Vertical Center",
    icon: "align_vertical_center",
  },
  {
    value: "objectsVerticalTop",
    label: "Objects Vertical Top",
    icon: "align_vertical_top",
  },
  {
    value: "party",
    label: "Party",
    icon: "celebration",
  },
  {
    value: "popsicle",
    label: "Popsicle",
    icon: "icecream",
  },
  {
    value: "reflectHorizontal",
    label: "Reflect Horizontal",
    icon: "flip",
  },
  {
    value: "reflectVertical",
    label: "Reflect Vertical",
    icon: "flip",
  },
  {
    value: "rfid",
    label: "RFID",
    icon: "contactless",
  },
  {
    value: "scatterChart",
    label: "Scatter Chart",
    icon: "scatter_plot",
  },
  {
    value: "shieldMinus",
    label: "Shield Minus",
    icon: "shield",
  },
  {
    value: "shieldPlus",
    label: "Shield Plus",
    icon: "shield",
  },
  {
    value: "shower",
    label: "Shower",
    icon: "shower",
  },
  {
    value: "signal",
    label: "Signal",
    icon: "signal_cellular_4_bar",
  },
  {
    value: "sushi",
    label: "Sushi",
    icon: "ramen_dining",
  },
  {
    value: "universalAccess",
    label: "Universal Access",
    icon: "accessibility",
  },
  {
    value: "verticalBottom",
    label: "Vertical Bottom",
    icon: "align_vertical_bottom",
  },
  {
    value: "verticalTop",
    label: "Vertical Top",
    icon: "align_vertical_top",
  },
  {
    value: "deezer",
    label: "Deezer",
    icon: "music_note", 
  }
]
 

